import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import moment from 'moment'
import Period from './Period'
import Frequency from './Frequency'
import DatePicker from './DatePicker'

import style from './style.sass'

@inject('store') @observer
class Time extends Component {
  changeStart = (date) => {
    this.props.store.analysis.change('period', null)
    this.props.store.analysis.change('start_dt', date)
    this.props.store.analysis.loadCandlestick()
  }
  changeEnd = (date) => {
    this.props.store.analysis.change('period', null)
    this.props.store.analysis.change('end_dt', date)
    this.props.store.analysis.loadCandlestick()
  }
  disabledStartDate = (startValue) => {
    const endValue = moment(this.props.store.analysis.end_dt)
    if (!startValue || !endValue) {
      return false
    }
    const {type, value} = this.additionalDisabledDates()
    return startValue.valueOf() > endValue.subtract(value, type).valueOf()
  }
  disabledEndDate = (endValue) => {
    const startValue = moment(this.props.store.analysis.start_dt)
    if (!endValue || !startValue) {
      return false
    }
    const {type, value} = this.additionalDisabledDates()
    return endValue.valueOf() <= startValue.add(value, type).valueOf()
  }
  additionalDisabledDates = () => {
    const {bar_size} = this.props.store.analysis
    switch(bar_size) {
    case 'monthly':
      return({type:'months', value:12})
    case 'weekly':
      return({type:'weeks', value:12})
    case 'daily':
      return({type:'days', value:12})
    case 'hourly':
      return({type:'hours', value:12})
    case '10-minute':
      return({type:'hours', value:2})
    case 'minute':
      return({type:'minutes', value:12})
    }
  }
  render() {
    const {analysis} = this.props.store
    return(
      <div styleName='wrapper'>
        <div>
          <Period/>
          <div styleName='frequency'>
            <span>
              Frequency:
            </span>
            <Frequency/>
          </div>
        </div>
        <div>
          <div styleName='start-date'>
            <DatePicker
              value={analysis.start_dt}
              handleChange={this.changeStart}
              disabledDate={this.disabledStartDate}
            />
          </div>
          <div styleName='end-date'>
            <DatePicker
              value={analysis.end_dt}
              handleChange={this.changeEnd}
              disabledDate={this.disabledEndDate}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Time
